import React from 'react';
import { withFeatureSafe } from 'Common/ErrorBoundaries';
import CustomInput from './CustomInput';

const CustomInputWithDollar = ({ extraClass = "", ...props }) => {
  return (
    <div className="relative">
      <span className="absolute z-[2] text-lg -translate-y-1/2 pointer-events-none left-2 top-[14px]">
        $
      </span>
      <CustomInput
        {...props}
        extraClass={`pl-5 ${extraClass}`}
      />
    </div>
  );
};

export default withFeatureSafe(CustomInputWithDollar);